import { queryOptions, useQuery } from '@tanstack/react-query'

import { ApiGateway } from '@/modules/api/api.gateway'
import { EmailTemplateRepository } from '@/modules/email-template/core/email-template.repository'
import { EmailTemplateService } from '@/modules/email-template/core/email-template.service'
import { EmailTemplatesScope } from '@/shared/domain/enums/email-templates-scope.enum'

const apiGateway = new ApiGateway()
const emailTemplateRepository = new EmailTemplateRepository(apiGateway)
const emailTemplateService = new EmailTemplateService(emailTemplateRepository)

const emailTemplateQueryOptions = (emailTemplateId?: string) =>
  queryOptions({
    enabled: !!emailTemplateId,
    queryFn: () =>
      emailTemplateId ? emailTemplateService.getById(emailTemplateId) : Promise.reject('No email template ID provided'),
    queryKey: ['emailTemplate', emailTemplateId],
  })

const useEmailTemplate = (emailTemplateId?: string) => {
  return useQuery(emailTemplateQueryOptions(emailTemplateId))
}

const emailTemplateByOrganization = (organizationId: string, scope: keyof typeof EmailTemplatesScope) =>
  queryOptions({
    queryFn: () => emailTemplateService.getByOrganization(organizationId, scope),
    queryKey: ['organizationEmailTemplates', organizationId, scope],
  })

const useEmailTemplatesByOrganization = (organizationId: string, scope: keyof typeof EmailTemplatesScope) => {
  return useQuery(emailTemplateByOrganization(organizationId, scope))
}

export { emailTemplateQueryOptions }
export { useEmailTemplate, useEmailTemplatesByOrganization }
